<template>
  <slide-modal
    v-show="true"
    @close-modal="$emit('close-modal')"
  >
    <template v-slot:header>
      New Note
    </template>
    <template v-slot:body>

    </template>
    <template v-slot:footer>
      <b-button
        class="btn btn-primary cabinet"
        @click="save"
      >Save</b-button>
    </template>
  </slide-modal>
</template>

<script>
import SlideModal from "@/components/SlideModal";

export default {
  name: "NotePanel",
  components: {
    SlideModal
  },
  methods: {
    save() {
      console.log("Pressed Save");
    }
  }
};
</script>
